import { NavigationPrefixIt } from '@ingenico/util-mfe-shell';
import type { BehaviorSubject } from 'rxjs';
import { appContainer } from '../hexa/appContainer.const';

// Mirrors what the m360 shells publish so useSectionsRoutePrefixHook resolves section prefixes in standalone mode.
export function publishNavigationPrefix(organizationName: string): void {
  const navigationPrefix$ = appContainer.get<BehaviorSubject<Record<string, string>>>(NavigationPrefixIt);

  navigationPrefix$.next({
    ...navigationPrefix$.value,
    deviceManagement: `/${organizationName}`,
  });
}
